module.exports = __webpack_public_path__ + "static/img/bg0.57803d0.png";